import LinkIcon from "@mui/icons-material/Link";
import { Table, TableCell, TableRow, TableBody, Box, CircularProgress } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import { useAnnouncements } from "./AnnoucementsContext";

const AnnouncementsList = () => {
  const { announcements, setSelectedAnnouncement, setSelectedAnnouncementLog } =
    useAnnouncements();
    if (announcements !=null && announcements.length > 0){
      return (
        <Table size="small">
          <TableBody>
            <TableRow className="report-header">
              <TableCell> ID </TableCell>
              <TableCell> Title </TableCell>
              <TableCell> Agency </TableCell>
              <TableCell> Author </TableCell>
              <TableCell> Priority </TableCell>
              {/* <TableCell> MoreInfoLink </TableCell> */}
              <TableCell> Expiration Date </TableCell>
              <TableCell> Logs </TableCell>
            </TableRow>
            {announcements.map((eachAnnouncement, idx) => {
              return (
                <TableRow
                  className={idx % 2 === 0 ? "styledtablerow" : ""}
                  key={eachAnnouncement.id}
                >
                  <TableCell>
                    <Link
                      className="hyper-links"
                      onClick={(e) => {
                        setSelectedAnnouncement(eachAnnouncement);
                      }}
                    >
                      {eachAnnouncement.id}
                    </Link>
                  </TableCell>
                  <TableCell align="left">
                    {/* <Link  className="hyper-links" onClick={(e)=>handleAnnouncement(eachAnnouncement.id,setOpenDispAnnouncement)}> */}
                    {eachAnnouncement.title}
                    {/* </Link> */}
                  </TableCell>
                  <TableCell>{eachAnnouncement.agency}</TableCell>
                  <TableCell>{eachAnnouncement.author}</TableCell>
                  <TableCell>{eachAnnouncement.priority}</TableCell>
                  {/* <TableCell>
                    <a href="{eachAnnouncement.link}" target="_blank" rel="noopener noreferrer" className="hyper-links" > {eachAnnouncement.link} </a>
                </TableCell> */}
                  <TableCell>{eachAnnouncement.expirationDate}</TableCell>
                  <TableCell>
                    <Link
                      style={{ textDecoration: "none" }}
                      className="hyper-links"
                      onClick={(e) => {
                        setSelectedAnnouncementLog(eachAnnouncement);
                      }}
                    >
                      {/* AnnouncementLogs */}
                      <LinkIcon fontSize="medium"  />
                    </Link>
                    
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      )}
      else{
        return(
          <Box sx={{ width: "100%", textAlign: "center", mt: 5 }}>
            <CircularProgress />
          </Box>
        )
      }
};

export default AnnouncementsList;
